import { Injectable } from '@angular/core';
import { delay, Observable, of } from 'rxjs';
import { fillArr } from '@pin-up-global/common';
import { ApiService, ListResponse } from '@shared/abstraction';
import { manageLoadingStatus } from '@shared/rxjs-operators';
import { BotTimezone } from './timezones.abstraction';

@Injectable()
export class TimezonesApiServiceMock extends ApiService {
  isLoading$ = this._isLoading$;

  getTimezones(): Observable<ListResponse<BotTimezone>> {
    return of({
      items: fillArr(5, id =>
        ({
          value: `timezone_${ id }`,
          label: `Timezone ${ id }`,
        }),
      ),
      count: 5,
    }).pipe(
      delay(1000),
      manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$),
    );
  }
}
